import { getUser } from '@dealstack/frontend/shared/dataExchange/services/auth.service';
import { FullscreenLoader } from '@dealstack/frontend/shared/components/loaders/FullLoaderScreenLoader/FullLoaderScreenLoader';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
	children?: React.ReactNode;
	defaultProtectedRoute: string;
}

export const GuestRoute = ({ defaultProtectedRoute, children }: Props) => {
	const [isLoading, setIsLoading] = useState(true);
	const navigate = useNavigate();

	// To check if the user is already logged in.
	// This API will return 401 if user has no valid tokens
	// any API will do the same checking thus the payload is not important
	// If you see a 401 error in the logs without a sessionId, it means the user visited our platform but wasn't logged in.
	const q = useQuery({
		queryKey: [API_PATHS.USER_GET],
		queryFn: getUser,
		enabled: false,
		retry: false,
		// Expected 401 when not logged in — handled below; no global error toast.
		meta: { suppressErrorToast: true },
	});

	useEffect(() => {
		void q.refetch();
	}, []);

	useEffect(() => {
		if (q.isSuccess) {
			navigate(defaultProtectedRoute);
		}
	}, [q.isSuccess]);

	useEffect(() => {
		if (q.isError) {
			setIsLoading(false);
		}
	}, [q.isError]);
	return <>{isLoading ? <FullscreenLoader name="guestRoute" /> : children}</>;
};
